/**
 * Hibajelentes az AVSentry-be — a KOZOS, tiszta resze.
 *
 * Itt csak olyan kod all, ami sem a Node-tol, sem a bongeszotol nem fugg:
 * a cim ertelmezese, a verem szetszedese es a keret osszeallitasa. A halozati
 * kuldes az alkalmazasokban van (`apps/server`, `apps/web`), mert ez a csomag
 * SZANDEKOSAN platform-fuggetlen - `fetch` es `crypto` nincs benne.
 *
 * **Miert sajat kod, es nem a hivatalos SDK?** A beküldés egyetlen HTTP POST -
 * ezt megmertem, mielott barmit irtam volna. Egy teljes SDK ehhez sok szaz
 * kilobajtot es egy kotelezo betoltesi sorrendet hozna magaval, ugyanezert.
 */
/**
 * A DSN szetszedese.
 *
 * Alakja: `https://<kulcs>@<hoszt>/<projekt>`. A kulcs SZANDEKOSAN nyilvanos -
 * bongeszo-alkalmazasokba is beleepul -, csak beküldésre jo, olvasasra nem.
 *
 * Hibas cimre `null`-t ad, NEM dob: egy elgepelt kornyezeti valtozo miatt nem
 * allhat meg a szerver, a hibajelentes hianya boven kisebb baj.
 */
export function parseDsn(dsn) {
    const match = /^(https?):\/\/([^@:/]+)@([^/]+)\/(.+)$/.exec(dsn.trim());
    if (!match)
        return null;
    const [, protocol, key, host, projectId] = match;
    return { key: key, url: `${protocol}://${host}/api/${projectId}/envelope/` };
}
const STACK_LINE = /^\s*at (?:(.+?)\s+\()?(?:(.+?):(\d+):(\d+)|([^)]+))\)?$/;
/**
 * A verem szetszedese kereteknek.
 *
 * Enelkul a szolgaltatas nem tudna CSOPORTOSITANI a hibakat: minden egyes
 * elofordulas kulon bejegyzeskent allna, es egy percenkent ismetlodo hiba par
 * ora alatt hasznalhatatlanna tenne a listat.
 *
 * A sorrend MEGFORDUL: a szolgaltatas a legkulsobb keretet varja elol.
 */
export function parseStack(stack) {
    if (!stack)
        return [];
    const frames = [];
    for (const line of stack.split('\n').slice(1)) {
        const match = STACK_LINE.exec(line);
        if (!match)
            continue;
        const filename = match[2] ?? match[5] ?? '?';
        frames.push({
            filename,
            function: match[1] ?? '?',
            ...(match[3] ? { lineno: Number(match[3]) } : {}),
            ...(match[4] ? { colno: Number(match[4]) } : {}),
            // Ami nem fuggoseg es nem beepitett modul, az a mi kodunk.
            in_app: !filename.includes('node_modules') && !filename.startsWith('node:'),
        });
    }
    return frames.reverse();
}
/** A beküldési fejlec. A kulcs nem titok - a bongeszo is ezzel kuld. */
export function authHeader(key) {
    return `Sentry sentry_version=7, sentry_key=${key}, sentry_client=avslack/1.0`;
}
/**
 * A keret osszeallitasa.
 *
 * Az azonositot es az idobelyeget a HIVO adja: azok platform-fuggo forrasbol
 * jonnek (`crypto`, `Date`), es ez a csomag azoktol fuggetlen marad.
 */
export function buildEnvelope(input) {
    const { eventId, sentAt, error, options, context } = input;
    const asError = error instanceof Error ? error : null;
    const message = asError?.message ?? String(error);
    const event = {
        event_id: eventId,
        timestamp: sentAt,
        platform: options.platform,
        level: context.level ?? 'error',
        environment: options.environment,
        ...(options.release ? { release: options.release } : {}),
        ...(options.serverName ? { server_name: options.serverName } : {}),
        exception: {
            values: [
                {
                    type: asError?.name ?? 'Error',
                    // A hatar nem onkenyes: egy vegtelen szoveg a listat is elrontana.
                    value: message.slice(0, 1000),
                    stacktrace: { frames: parseStack(asError?.stack) },
                },
            ],
        },
        tags: {
            ...(context.where ? { hol: context.where } : {}),
            ...context.tags,
        },
        ...(context.user ? { user: context.user } : {}),
        ...(context.extra ? { extra: context.extra } : {}),
    };
    return [
        JSON.stringify({ event_id: eventId, sent_at: sentAt }),
        JSON.stringify({ type: 'event' }),
        JSON.stringify(event),
    ].join('\n');
}
//# sourceMappingURL=error-report.js.map